// extracted by mini-css-extract-plugin
export default {"date":"_209Xe","eventList":"_3CRKE","dateText":"_3ZrtZ","eventDetails":"_3xTQV","dateWithChevron":"_3pHFc","dateChevron":"_3y2iB","close":"_1jZ4r"};